<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Research</b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Academinc Indirect Cost</b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Pay Periods</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ payPeriodStartDate | moment('MMMM YYYY') }}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="card-header">
              <ul class="card-header-tabs nav nav-tabs">
                  <li class="nav-item">
                      <a @click="currentTabComponent='TheAdLocList'" :class="currentTabComponent === 'TheAdLocList' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">AICD Review</a>
                  </li>
                  <li class="nav-item">
                      <a @click="currentTabComponent='TheFundTransfer'" :class="currentTabComponent === 'TheFundTransfer' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">Fund Transfer</a>
                  </li>
                  <li class="nav-item">
                      <a @click="currentTabComponent='TheAttachmentsList'" :class="currentTabComponent === 'TheAttachmentsList' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">Documents</a>
                  </li>
                  <li class="nav-item">
                      <a @click="currentTabComponent='TheCertificationList'" :class="currentTabComponent === 'TheCertificationList' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">Certify &amp; Close</a>
                  </li>
              </ul>
            </div>
            <div class="card-body">
              <fieldset class="border p-3 mb-2" style="height: 100%;">
                  <div><b>Fiscal Year:</b> {{ fiscalYear }}</div>
                  <div><b>Period:</b> {{ payPeriodStartDate | moment('MMMM YYYY') }}</div>
              </fieldset>
              <div id="tab-container">
                  <component  :is="currentTabComponent" 
                              :adLoc="adLoc" 
                              :fiscalYear="fiscalYear" 
                              :payPeriodStartDate="payPeriodStartDate"
                              :canEdit="canEdit" 
                              :departmentName="departmentName"
                              :payPeriodId="payPeriodId"
                              :payPeriodStartDateDisplay="payPeriodStartDateDisplay" />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import TheAdLocList from "@/components/academicIndirectCost/TheAdLocList.vue";
import TheFundTransfer from "@/components/academicIndirectCost/TheFundTransfer.vue";
import TheAttachmentsList from "@/components/academicIndirectCost/TheAttachmentsList.vue";
import TheCertificationList from "@/components/academicIndirectCost/TheCertificationList.vue";

export default {
    components: {
      TheAdLocList,
      TheFundTransfer,
      TheAttachmentsList,
      TheCertificationList
    },
    props: {
      adLoc: {
        required: true,
        type: String
      },
      fiscalYear: {
        required: true,
        type: Number
      },
      payPeriodId: {
        required: true,
        type: String
      },
      payPeriodStartDate: {
        required: true,
        type: Date
      },
      canEdit: {
        required: true,
        type: Boolean
      },
      payPeriodStartDateDisplay: {
        required: true,
        type: String
      }
    },
    data() {
        return {
            currentTabComponent: "TheAdLocList"
        }
    }
}
</script>
